import {connect} from 'react-redux';
import {Container, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {useMsal} from '@azure/msal-react';
import {useEffect, useState} from 'react';
import {selectActiveLink} from './navbarSlice';
import {useAppSelector} from '../../app/hooks';
import {apiRequest} from '../../authConfig';
import styles from './NavMenu.module.css';
import {useNavigate} from 'react-router-dom';

const NavMenu = () => {
    const {instance, accounts} = useMsal();
    const name = accounts[0] && accounts[0].name;
    const activeLink = useAppSelector(selectActiveLink);
    const navigate = useNavigate();
    const [healthLinkActive, setHealthLinkActive] = useState(false);
    const [customerLinkActive, setCustomerLinkActive] = useState(false);
    const [notesLinkActive, setNotesLinkActive] = useState(false);

    useEffect(() => {
        const requestApiAccessToken = async (): Promise<string> => {
            const request = {
                ...apiRequest,
                account: accounts[0],
            };

            try {
                const response = await instance.acquireTokenSilent(request);
                return response.accessToken;
            } catch (error) {
                const response = await instance.acquireTokenSilent(request);
                return response.accessToken;
            }
        };

        const fetchData = async () => {
            return await requestApiAccessToken();
        };

        fetchData().then((_) => {
            setHealthLinkActive(activeLink === '/health');
            setCustomerLinkActive(activeLink === '/customers');
            setNotesLinkActive(activeLink === '/notes');
        });
    }, [accounts, activeLink, instance]);

    useEffect(() => {
        setHealthLinkActive(activeLink === '/health');
        setCustomerLinkActive(activeLink === '/customers');
        setNotesLinkActive(activeLink === '/notes');
    }, [activeLink]);

    const handleDropdownSelect = (eventKey: any) => {
        if (eventKey === "3.1") {
            navigate('/profile');
        }
        if (eventKey === '3.2') {
            instance.logoutPopup({
                mainWindowRedirectUri: '/',
                ...apiRequest,
                account: accounts[0],
            });
        }
    };

    return (
        <Navbar className={styles.menu} bg="light" expand="lg">
            <Container fluid>
                <Navbar.Brand href="/">Office Tools</Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll"/>
                <Navbar.Collapse id="navbarScroll">
                    <Nav className="me-auto my-2 my-lg-0">
                        <Nav.Item>
                            <Nav.Link active={healthLinkActive} href="/health">
                                Health
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link active={customerLinkActive} href="/customers">
                                Customers
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link active={notesLinkActive} href="/notes">
                                Notes
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Nav onSelect={handleDropdownSelect}>
                        <NavDropdown title={name} id="basic-nav-dropdown">
                            <NavDropdown.Item eventKey="3.1">
                                Profile
                            </NavDropdown.Item>
                            <NavDropdown.Item eventKey="3.2">
                                Logout
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default connect()(NavMenu);
